export default "__VITE_ASSET__Bvl4mWPY__"